import { render, staticRenderFns } from "./UpdateCourseModal.vue?vue&type=template&id=12feaba6&"
import script from "./UpdateCourseModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCourseModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCourseModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports